import React, {Component} from 'react';

let FilaInformativa = (props)=>{
    return(
        <div className="row">
        {
          props.columnas.map((el, i)=>{
                return(
                    <div key={i} className={'col-md-'+(12/props.columnas.length)}>
                        <div className="card">
                <h6 className="card-header bg-info text-center">{el.icono} {el.titulo}</h6>
                                <div className="card-body">
                                    <div className="text-center">
                                          <h6 className="h5 text-center"> {el.signo}{el.dato}</h6>
                                    </div>
                                      
                                </div>
                        </div>
                    </div>
                )
            })
        }
    </div>
    )
}

export default FilaInformativa;